var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item",class:_vm.selectedList.findIndex((element) => _vm.item.id === element.id) > -1
      ? 'active'
      : '',on:{"click":_vm.onClick}},[_c('div',[_vm._v(" "+_vm._s(_vm.item.name)+" ")]),_c('div',[_vm._v(" "+_vm._s(_vm.item.mobile)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }